// extracted by mini-css-extract-plugin
module.exports = {"titleDesktop":"MenuElement_titleDesktop__RBpWZ","titleMobile":"MenuElement_titleMobile__U8Z9S"};